import Component from '../core/Component'
import PositionObserver from '../meta/PositionObserver'

export default class FacilitiesAnimation extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: [],
            contents: []
        }

        this.isActive = false

        this.resizeTimer = null
        this.columnMapper = {}
        this.items = []
    }

    prepare() {
        this.items = this.ref.items.map((element, index) => ({
            element,
            column: 0,
            content: this.ref.contents[index]
        }))

        this.observer = new PositionObserver(this.element, {
            onEnter: this.handleEnter,
            onLeave: this.handleLeave,
            onRender: this.handleRender,
            onBeforeResize: this.handleBeforeResize
        })
    }

    destroy() {
        if (this.observer) {
            this.observer.destroy()
        }

        this.observer = null
    }

    handleBeforeResize = () => {
        this.resize()

        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => this.resize(), 1000)
    }

    handleEnter = () => {
        this.isActive = true
    }

    handleLeave = () => {
        this.isActive = false
    }

    handleRender = ({ ratio }) => {
        if (!this.isActive) {
            return
        }

        ratio = Math.min(ratio, 0)

        this.items.forEach(item => {
            item.content.style.transform = `translateY(${this.columnMapper[item.left] * ratio * (-25)}px)`
        })
    }

    resize() {
        const items = this.items
            .map(item => ({
                ...item,
                left: parseInt(item.element.getBoundingClientRect().left)
            }))

        //mapping left to column index
        this.columnMapper = [...new Set(this.items.map(item => item.left))].sort((a, b) => a - b).reduce((acc, left, index) => {
            acc[left] = index
            return acc
        }, {})

        this.items = items
    }
}
